import { connect } from 'react-redux';
import { compose, withHandlers } from 'recompose';
import { withFormSelector } from '../helpers';
import Profile from '../components/Profile';
import { getActiveType, getShopBrand, isBrandViewActive } from '../../../../../auth/selectors';
import { getUserHasRentalBarberInSameProfile } from '../../../selector';
import { fieldNameInFormSection } from '../../../containers/BrandBarber/helpers/formValuesHelpers';

const ProfileContainer = compose(
  withFormSelector,
  connect((state, { selector, ...props }) => {
    const shopBrand = getShopBrand(state);
    const isNoBrandOrSingleShopBrand = getActiveType(state) === 'shop' && (!shopBrand || shopBrand.shopCount === 1);
    const isBrand = isBrandViewActive(state);
    const userHasRentalBarberInSameProfile = getUserHasRentalBarberInSameProfile(state);

    return {
      disableUsername: selector(state, 'populateUsername'),
      instagramUserId: selector(state, 'instagramUserId'),
      instagram: selector(state, 'instagram'),
      currentEmailValue: selector(state, 'email'),
      currentUsernameValue: selector(state, 'username'),
      isUserEnabled: selector(state, 'userEnabled'),
      avatar: selector(state, 'avatar'),
      canEditBarberName:
        !props.edit
        || (isBrand || isNoBrandOrSingleShopBrand || userHasRentalBarberInSameProfile),
      canEditBarberPersonnelId:
        !props.edit
        || (isBrand || isNoBrandOrSingleShopBrand),
    };
  }),
  withHandlers({
    onPopulateUsernameChange: (props) => (e) => {
      const populateUsernameFromEmail = e.target.checked;

      const newEmailValue = populateUsernameFromEmail ? props.currentEmailValue : '';
      props.change(fieldNameInFormSection(props.sectionPrefix, 'username'), newEmailValue);
    },
    onEmailChange: (props) => (e) => {
      if (props.disableUsername) {
        const newEmailValue = e.target.value;
        props.change(fieldNameInFormSection(props.sectionPrefix, 'username'), newEmailValue);
      }
    },
  })
)(Profile);

export default ProfileContainer;
